export enum NotifyType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error'
}

type NotifyUserOpts = {
  msg: string;
  type?: string;
  time?: number;
  width?: string;
  onInit?(devExEvent: unknown): void;
};

export type NotifyUser = (opts: NotifyUserOpts) => void;
